import * as Sentry from '@sentry/vue';
import { RiskledgerSessionIdHeader } from '@/api/headerKeys';
import type AnalyticsModule from './analyticsModule';
import type { SetUserPropertiesParams } from './analyticsModule';

export default class implements AnalyticsModule {
  constructor() {
    if (import.meta.env.MODE === 'prod') {
      // https://docs.sentry.io/platforms/javascript/guides/vue/features/vue-router/
      Sentry.browserTracingIntegration({
        routeLabel: 'path',
      });
    }
  }

  trackEvent(_eventName: string, _properties: Record<string, any>) {
    // NOOP
    // Only using Sentry for error tracking right now
  }

  logError(error: any, { route }: Record<string, any>) {
    // https://docs.sentry.io/platforms/javascript/guides/vue/usage/
    // Sends error to Sentry with optional tags and extras
    Sentry.captureException(error, {
      extra: { route },
    });
  }

  // https://docs.sentry.io/platforms/javascript/guides/vue/enriching-events/identify-user/
  setUserProperties({ user, org }: SetUserPropertiesParams) {
    if (!user || !org) return;
    Sentry.setUser({
      // User
      id: user.userID,
      username: `${user.firstName} ${user.lastName}`,
      email: user.email,

      'Cognito ID': user.cognitoID,
      'Created At': user.createdAt,
      'Activated At': user.activatedAt,
      Status: user.status,
      Role: user.role,
      Team: user.team,

      // Organisation
      'Organisation ID': org.orgID,
      'Org Status': org.status,
      Paid: org.paid,
      Location: org.location,
      Supplier: org.isSupplier,
      Client: org.isClient,
    });

    // https://docs.sentry.io/platforms/javascript/enriching-events/tags/
    // Retrieve session ID directly from sessionStorage
    const sessionID = sessionStorage.getItem(RiskledgerSessionIdHeader);
    if (sessionID) {
      Sentry.setTag('session_id', sessionID);
    }
  }

  reset() {
    // NOOP
  }

  trackView() {
    // NOOP
  }
}
